// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/font.css
// module id = RXC7
// module chunks = 14